import { useLocation, useSearchParams } from 'react-router-dom';
import { useInitializationDataContext } from '../../../context/data-context';
import { EnvelopeCode, EnvelopeType } from '../../../global-types/envelope';
import { getEnvelopeTypeByCode } from '../../../utils/address/get-envelope-type-by-code';

export const useGetProjectCurrentEnvelope = () => {
  const { search } = useLocation();
  const [searchParams] = useSearchParams(search);
  const {
    initializedDataState: { data: initializedData },
  } = useInitializationDataContext();

  const getProjectCurrentEnvelopeType = () => {
    const currentEnvelope = searchParams.get('envelope');
    if (currentEnvelope !== null) {
      return currentEnvelope as EnvelopeType;
    }
    if (initializedData?.envelope_type) {
      return getEnvelopeTypeByCode(initializedData.envelope_type as EnvelopeCode);
    }
    return EnvelopeType.Blank;
  };

  return { getProjectCurrentEnvelopeType };
};
